import React from "react";

const TABS = [
  { k: "personal", label: "Personal",  testId: "agenda-tab-personal" },
  { k: "local",    label: "Iglesia",   testId: "agenda-tab-local"    },
  { k: "field",    label: "Campo",     testId: "agenda-tab-field"    },
];

export default function AgendaTabs({ tab, onChange }) {
  return (
    <div
      className="flex gap-1 bg-slate-200/50 dark:bg-slate-700/50 supports-[backdrop-filter]:bg-slate-200/30 dark:supports-[backdrop-filter]:bg-slate-700/30 backdrop-blur-xl rounded-full p-1 border border-slate-200/30 dark:border-slate-600/30"
      data-testid="agenda-tabs"
    >
      {TABS.map((t) => (
        <button
          key={t.k}
          onClick={() => onChange(t.k)}
          data-testid={t.testId}
          className={`
            flex-1 h-11 flex items-center justify-center rounded-[20px] text-[11px] font-semibold
            transition-all duration-200 ease-out active:scale-[0.98] active:opacity-80
            ${tab === t.k
              ? "bg-white/90 dark:bg-slate-800/90 text-brand shadow-[0_2px_8px_rgba(0,0,0,0.04)]"
              : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"}
          `}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
